import React, {useEffect, useState} from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import Popup from "../../../../component/Popup/Popup";
import {Button, Form} from "react-bootstrap";
import InputsPreviewAntecipacao from "./InputsPreviewAntecipacao";
import CurrencyInput from "../../../../component/CurrencyInput";
import TextField from "@mui/material/TextField";
import {InputLabelProps} from "../../../../utils/InputLabelProps";
import {handleChangeValue} from "../../../../utils/handleChangeValue";
import {NumericFormat} from "react-number-format";
import SettingsIcon from "@mui/icons-material/Settings";
import axios from "axios";
import {useUser} from "../../../../auth/AuthProvider";

export default function PopupManageFees({
                                            taxaAdmin, setTaxaAdmin,
                                            taxaAntecipacao, setTaxaAntecipacao,
                                            baseUrl, item
                                        }) {

    // Modal control
    const [lgShow, setLgShow] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [blockSubmit, setBlockSubmit] = useState(false)

    const itemToState = () => {
        setTaxaAdmin(taxaAdmin)
        setTaxaAntecipacao(taxaAntecipacao)
    }

    useEffect(() => {
        if (!lgShow)
            if (itemToState)
                itemToState()
    }, [lgShow]);

    // Modal data
    const icon = <DescriptionIcon fontSize="large" id="icon-svg"/>
    const title = 'Alterar taxas de simulação'
    const iconSpan = (
        <>
            {icon}
            <h3>{title}</h3>
        </>
    );

    const handleSave = () => {
        const data = {
            adminFee: taxaAdmin,
            anticipationFee: taxaAntecipacao
        };
        if (!blockSubmit) {
            setIsLoading(true)
            axios.put(baseUrl, data)
                .then(() => {
                    console.log("Taxas atualizadas com sucesso!");
                    setLgShow(false); // Fecha o modal após salvar
                })
                .catch(error => {
                    console.log(error);
                    console.log("Erro ao atualizar as taxas.");
                });
        }
    };




    return <>
        <Popup
            backdrop="static"
            title={title}
            iconSpan={iconSpan}
            buttonText={<SettingsIcon fontSize="medium"/>}
            lgShow={lgShow}
            setLgShow={setLgShow}
            buttonClass={"btn btn-outline-dark button-show m-2 mt-0"}
        >
            <div>
                <Form onSubmit={handleSave} className="form-inputs">
                <div className='mt-3'>

                <NumericFormat
                    label="Taxa de administração"
                    customInput={TextField}
                    value={taxaAdmin}
                    suffix=' %'
                    inputProps={{
                        min: 1,
                        step: ".01"
                    }}
                    onValueChange={(e) => handleChangeValue(e, setTaxaAdmin)}
                    InputLabelProps={InputLabelProps}
                    required
                    thousandSeparator="."
                    decimalSeparator=","
                    fullWidth
                />
                <NumericFormat
                    label="Taxa de antecipação"
                    customInput={TextField}
                    value={taxaAntecipacao}
                    suffix=' %'
                    inputProps={{
                        min: 1,
                        step: ".01"
                    }}
                    onValueChange={(e) => handleChangeValue(e, setTaxaAntecipacao)}
                    InputLabelProps={InputLabelProps}
                    required
                    thousandSeparator="."
                    decimalSeparator=","
                    fullWidth
                />
            </div>
                <Button
                    type="submit"
                >
                    {isLoading ? (
                        <>
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                            Aguarde...
                        </>
                    ) : (
                        "Salvar Alterações"
                    )}
                </Button>
                </Form>
            </div>
        </Popup>
    </>
}